import labels from "app/labels";
import * as ko from "knockout";
import * as moment from "moment";

export class MeterReadingValue {
  contract_id: KnockoutObservable<string>;
  meter_value: KnockoutObservable<string>;
  meter_value_new: KnockoutObservable<string>;
  model_id: KnockoutObservable<string>;
  serial_id: KnockoutObservable<string>;
  status: KnockoutObservable<string>;
  verified_error_text: KnockoutObservable<string>;
  task_id: KnockoutObservable<string>;
  meter_name: KnockoutObservable<string>;
  latest_meter_value: KnockoutObservable<string>;
  latest_reading_date: KnockoutObservable<string>;
  sequence: KnockoutObservable<number>;
  reading_date_dttm: KnockoutObservable<Date>;
  reading_date: KnockoutComputed<string>;
  visiting_address: KnockoutObservable<string>;
  earliest_read_dt: KnockoutObservable<string>;
  latest_read_dt: KnockoutObservable<string>;

  constructor(item) {
    if (item.contract) this.contract_id = ko.observable(item.contract.contract_id);
    else if (item.contract_id) this.contract_id = ko.observable(item.contract_id);
    this.meter_value = ko.observable(item.meter_value);
    this.model_id = ko.observable(item.model_id);
    this.serial_id = ko.observable(item.serial_id);
    this.status = ko.observable(item.status);
    this.verified_error_text = ko.observable(item.verified_error_text);
    this.task_id = ko.observable(item.task_id);
    this.meter_name = ko.observable(item.meter_name);
    this.latest_meter_value = ko.observable(item.latest_meter_value ? parseInt(item.latest_meter_value, 10) + "" : "");
    this.latest_reading_date = ko.pureComputed(() => {
      if (item.latest_reading_date) {
        return moment(item.latest_reading_date).format("DD-MM-YYYY HH:ss");
      } else {
        return;
      }
    });
    this.sequence = ko.pureComputed(() => {
      return item.sequence ? item.sequence : 0;
    });

    this.earliest_read_dt = ko.observable(item.earliest_read_dt);
    this.latest_read_dt = ko.observable(item.latest_read_dt);

    this.reading_date_dttm = ko.observable(item.reading_date ? new Date(item.reading_date) : undefined).extend({
      validation: {
        validator: (
          value: Date,
          params: { earliest: KnockoutObservable<string>; latest: KnockoutObservable<string> },
        ) => {
          return this.isReadingDateWithinRange(value, params.earliest(), params.latest());
        },
        message: this.getReadingDateRangeMessage(),
        params: {
          earliest: this.earliest_read_dt,
          latest: this.latest_read_dt,
        },
      },
    });

    this.reading_date = ko.computed(() => {
      if (this.reading_date_dttm()) {
        return moment(this.reading_date_dttm()).format("DD/MM/YYYY");
      } else {
        return "";
      }
    });
    this.visiting_address = ko.observable(item?.product?.place_address?.address?.name);

    this.meter_value_new = ko.observable(item.meter_value).extend({
      min: {
        params: this.latest_meter_value(),
        message: labels.descrWithParams("cc_P_METER_READING_VALUE_ERROR", [this.latest_meter_value()]),
      },
    });
  }

  private normalizeReadingDate = (value?: string | Date) => {
    if (!value) {
      return null;
    }

    const normalized = moment(value);
    if (!normalized.isValid()) {
      return null;
    }

    return normalized.startOf("day");
  };

  private formatReadingDate = (value?: string | Date) => {
    const normalized = this.normalizeReadingDate(value);
    return normalized ? normalized.format("DD/MM/YYYY") : "";
  };

  private isReadingDateWithinRange = (value?: Date, earliestValue?: string, latestValue?: string) => {
    if (!value) {
      return true;
    }

    const readingDate = this.normalizeReadingDate(value);
    const earliestDate = this.normalizeReadingDate(earliestValue);
    const latestDate = this.normalizeReadingDate(latestValue);

    if (!readingDate || !earliestDate || !latestDate) {
      return true;
    }

    return readingDate.isBetween(earliestDate, latestDate, undefined, "[]");
  };

  private getReadingDateRangeMessage = () => {
    const earliestDate = this.formatReadingDate(this.earliest_read_dt && this.earliest_read_dt());
    const latestDate = this.formatReadingDate(this.latest_read_dt && this.latest_read_dt());

    return labels.descrWithParams("cc_P_METER_READING_DATE_RANGE_ERROR", [earliestDate, latestDate]);
  };
}
